import store from './index';
export const selectPublicCompanies = () => store(({ publicCompanies }) => publicCompanies);
export const selectCompanies = () => store(({ companies }) => companies);
export const selectCompany = () => store(({ company }) => company);
export const selectCompanyUnits = () => store(({ company }) => company?.units);
export const selectResaleCompanies = () => store(({ resaleCompanies }) => resaleCompanies);
export default {
    getPublicCompanies: store.getState().getPublicCompanies,
    changePublicCompany: store.getState().changePublicCompany,
    setSelectedPublicCompanies: store.getState().setSelectedPublicCompanies,
    toggleSelectedPublicCompany: store.getState().toggleSelectedPublicCompany,
    resetSelectedPublicCompanies: store.getState().resetSelectedPublicCompanies,
    getCompanies: store.getState().getCompanies,
    getCompany: store.getState().getCompany,
    createCompany: store.getState().createCompany,
    editCompany: store.getState().editCompany,
    deleteCompany: store.getState().deleteCompany,
    getResaleCompanies: store.getState().getResaleCompanies,
    getResaleCompanyUnitsForAdmins: store.getState().getResaleCompanyUnitsForAdmins,
    getCompanyResaleUnitsForBrokers: store.getState().getCompanyResaleUnitsForBrokers,
    downloadCompanyResaleUnits: store.getState().downloadCompanyResaleUnits,
    createUnit: store.getState().createUnit,
    updateUnit: store.getState().updateUnit,
    publishResaleUnit: store.getState().publishResaleUnit,
    declineResaleUnit: store.getState().declineResaleUnit,
    deleteUnit: store.getState().deleteUnit,
    attachLayouts: store.getState().attachLayouts,
    changeUnitCreator: store.getState().changeUnitCreator,
    regenerateRegistrationToken: store.getState().regenerateRegistrationToken,
    validateRegistrationUrl: store.getState().validateRegistrationUrl,
    registrationRequest: store.getState().registrationRequest,
};
